<template>
  <div>
    <b-row align-h="center" style="margin-bottom: 40px; text-align: center" v-if="activeContent === 'select-credit'">
      <b-col cols="12" md="4">
        <h2 class="font-weight-bold mb-5">Select Credit Amount</h2>
        <b-form-group style="margin-bottom: 56px">
          <div class="w-100 d-flex justify-content-between mb-4">
            <div class="d-flex flex-column text-right align-items-end">
              <b-form-select
                v-model="selectedCredit"
                :options="list"
                class="mb-0"
                style="width: 150px"
              ></b-form-select>
            </div>
            <div class="d-flex flex-column text-left">
              <span>{{priceDollar}}</span>
              <small class="text-muted">{{approxText}}</small>
            </div>
          </div>
        </b-form-group>
        <b-form-group>
          <h5 class="font-weight-bold mb-5 text-left">Who are you buying this for</h5>
          <div class="w-100 d-flex justify-content-between mb-4">
            <div class="form-check">
              <input class="form-check-input" type="radio" v-model="buyForSelf" id="for-self" name="buyForSelf"  :value="true">
              <label class="form-check-label ml-4" for="for-self">
                <h4 class="d-flex text-left">Myself</h4>
                <p class="text-muted text-left">
                  Buying for yourself will automatically add the balance to your account
                </p>
              </label>
            </div>
          </div>
          <div class="w-100 d-flex justify-content-between mb-4">
            <div class="form-check">
              <input class="form-check-input" type="radio" v-model="buyForSelf" id="for-other" name="buyForSelf"  :value="false">
              <label class="form-check-label ml-4" for="for-other">
                <h4 class="d-flex text-left">For Someone Else</h4>
                <p class="text-muted text-left">
                  Buying for someone else will generate redemption code that they can redeem within the app
                </p>
              </label>
            </div>
          </div>
        </b-form-group>
        <button class="btn btn-primary btn-block" @click="goToPaymentMethod">Go to payment method</button>
        <div class="text-left mb-4">
          <small class="text-left">*All prices exclusive of Stripe fees</small>
        </div>
      </b-col>
      <div class="w-100"></div>
      <b-col cols="12" md="4" class="d-flex justify-content-center">
        <a class="btn-back d-flex rounded-circle cursor-pointer" @click="back">
          <font-awesome-icon :icon="['fas', 'chevron-left']" class="icon-back" />
        </a>
      </b-col>
    </b-row>
    <b-row align-h="center"  style="margin-bottom: 40px; text-align: center" v-if="activeContent === 'select-payment'">
      <b-col cols="12" md="4">
        <div class="payment-container">
          <h4 class="font-weight-bold mb-4">Select Payment</h4>
          <div class="d-flex flex-column">
            <div class="d-flex flex-column">
              <span class="small-muted-text text-left">CARD</span>
              <div class="d-flex flex-column" style="margin-bottom: 68px">
                <div class="d-flex">
                  <div class="input-radio-payment">
                    <input type="radio" name="payment_method" value="credit_card" v-model="paymentMethod"  />
                  </div>
                  <div class="payment-method-label w-100 text-left">
                    Credit Card / Debit Card
                  </div>
                  <div class="payment-method-images d-flex justify-content-end">
                    <img src="@/assets/visa.png" alt="logo" />
                    <img src="@/assets/master.png" alt="logo" />
                    <img src="@/assets/american-express.png" alt="logo" />
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex flex-column">
              <span class="small-muted-text text-left">WALLET</span>
              <div class="d-flex flex-column" style="margin-bottom: 40px">
                <div class="d-flex payment-item justify-content-between" v-if="false">
                  <div class="input-radio-payment">
                    <input type="radio" name="payment_method" value="grab_pay" v-model="paymentMethod" disabled />
                  </div>
                  <div class="payment-method-label text-left w-100">
                    GrabPay
                  </div>
                  <div class="payment-method-images d-flex justify-content-end">
                    <img src="@/assets/grabpay.png" alt="logo" />
                  </div>
                </div>
                <div class="d-flex payment-item justify-content-between" v-if="false">
                  <div class="input-radio-payment">
                    <input type="radio" name="payment_method" value="gcash" v-model="paymentMethod" disabled />
                  </div>
                  <div class="payment-method-label text-left w-100">
                    GCash
                  </div>
                  <div class="payment-method-images d-flex justify-content-end">
                    <img src="@/assets/gcash.png" alt="logo" />
                  </div>
                </div>
                <div class="d-flex payment-item justify-content-between">
                  <div class="input-radio-payment">
                    <input type="radio" name="payment_method" value="wechat" v-model="paymentMethod" />
                  </div>
                  <div class="payment-method-label text-left w-100">
                    WeChat Pay
                  </div>
                  <div class="payment-method-images d-flex justify-content-end">
                    <img src="@/assets/wechat.png" alt="logo" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <button class="btn btn-primary btn-block mb-3 mt-5" @click="pay">Go to payment</button>
          <div class="text-center d-flex flex-column align-items-start">
            <span  style="margin-top:5px;margin-bottom: -3px;">*All prices exclusive of service fee</span>
          </div>
        </div>
      </b-col>
      <div class="w-100"></div>
      <b-col cols="12" md="4" class="d-flex justify-content-center mt-5">
        <a class="btn-back d-flex rounded-circle cursor-pointer" @click="backPayment">
          <font-awesome-icon :icon="['fas', 'chevron-left']" class="icon-back" />
        </a>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from 'vuex';
import helperMixins from '../mixins/helpers.mixins'
const BASE_URL = process.env.BASE_URL;
export default {
  name: "TopUpPage",
  mixins:[helperMixins],
  data() {
    return {
      activeContent: 'select-credit',
      buyForSelf : true,
      showPrice : false,
      list:[],
      selectedCredit:null,
      creditData:null,
      paymentMethod: null
    }
  },
  async mounted(){
    this.list = [];
    if(this.creditTrxData!==''){
      Vue.swal({
        title: 'Warning',
        text: 'The other transaction are on the way. please finish them up before taking new transaction',
        icon: 'warning',
        confirmButtonText: 'Continue Payment',
        cancelButtonText: 'Cancel Transaction',
        showConfirmButton: true,
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-danger"
        }
      }).then(async (result) => {
        if(result.value){
          await this.$stripe.redirectToCheckout({
            sessionId:this.creditTrxData.session_id
          })
        }else{
          this.removePaymentData();
          this.$router.push({ name: 'HomePage' });
        }

      });
    }else{
      const listCredits = await this.requestListCredits();
      let messageError = '';
      if(this.getStatus !==200 ){
        messageError = this.getMessage;
      }else if(listCredits.length===0){
        messageError = 'No option available yet for your country yet. Please try again later';
      }
      if(messageError!==''){
        if (this.getStatus == 401){
          Vue.swal({
            title: 'Happy Sabbath!',
            text: messageError,
            confirmButtonText: 'Yes',
            cancelButtonText: 'Back to Home',
            showConfirmButton: false,
            showCancelButton: true,
          }).then(async (result) => {
            this.$router.push({ name: 'HomePage' });
          });
        }else{
          Vue.swal({
            title: 'Warning',
            text: messageError,
            icon: 'warning',
            confirmButtonText: 'Yes',
            cancelButtonText: 'Back to Home',
            showConfirmButton: false,
            showCancelButton: true,
          }).then(async (result) => {
            this.$router.push({ name: 'HomePage' });
          });
        }
      }
    }
  },
  computed:{
    ...mapGetters('CreditsAmountModule', ['listCredits']),
    ...mapGetters('PaymentModule', ['creditTrxData']),
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    ...mapGetters('AuthModule', ['getUser']),
    priceDollar(){
      if(!!this.selectedCredit){
        return `${this.selectedCredit.currency} ${this.selectedCredit.price_dollar}`
      }
      return ``
    },
    approxText() {
      if (!!this.selectedCredit) {
        return `Approx ${this.selectedCredit.user_currency} ${this.formatPrice((this.selectedCredit.price_dollar * this.selectedCredit.rate).toFixed(2))}`;
      }
      return ``
    }
  },
  watch: {
    listCredits: {
      immediate: true,
      deep: true,
      async handler(val) {
        this.data = this.listCredits;
        this.list = this.listCredits.map(cr => {
          return {
            value: {...cr},
            text: `${cr.price_credit} Credits`
          }
        })
        if(this.listCredits.length>0){
          this.selectedCredit = {...this.listCredits[0]}
        }
      }
    }
  },
  methods:{
    ...mapActions('CreditsAmountModule', ['requestListCredits']),
    ...mapActions('PaymentModule', ['setPaymentData','requestMakePayment','requestMakePaymentWeChat','removePaymentData']),
    ...mapActions('NotificationModule', ['setLoading','unsetLoading']),
    selectPrice(item){
      this.creditData = {
        country:item.country,
        currency:item.currency,
        identifier:item.identifier,
        price_credit:item.price_credit,
        price_dollar:item.price_dollar,
      }
    },
    goToPaymentMethod(){
      this.activeContent = 'select-payment';
    },
    backPayment(){
      this.activeContent = 'select-credit';
    },
    async pay(){
      if(this.paymentMethod === null){
        Vue.swal({
          title: 'Error',
          text: 'Please Select Payment Method',
          icon: 'error',
          cancelButtonText: 'Close',
          showConfirmButton: false,
          showCancelButton: true,
        });
      }else{
        this.creditData = {...this.selectedCredit,type:this.buyForSelf?'self':'other'};

        const type = this.buyForSelf?1:2;
        const data = {
          currency: this.creditData.currency, // dari credit-list -> currency
          amount: this.creditData.price_dollar, // dari credit-list -> price_dollar
          credit: this.creditData.price_credit, // dari credit-list -> price_credit
          identifier: this.creditData.identifier, // dari credit-list -> identifier
          purchasefor:type,
          success_url: BASE_URL+'/#/success?type='+(this.buyForSelf?'self':'other'),
          cancel_url: BASE_URL+'/#/transaction-failed',
        };
        const session = this.paymentMethod === 'wechat'?await this.requestMakePaymentWeChat(data):await this.requestMakePayment(data)
        this.creditData = {...this.creditData,session_id:session.id,paymentMethod:this.paymentMethod};
        this.setPaymentData(this.creditData);
        this.setLoading();
        await this.$stripe.redirectToCheckout({sessionId:session.id});
        this.unsetLoading();
      }

    },
    back(){
      this.$router.push({ name: 'HomePage' });
    }
  }
}
</script>

<style scoped>
  .btn-back{
    background: #C4C4C4;
    display: flex;
    width: 42px;
    height: 42px;
    cursor: pointer;
  }
  .icon-back{
    display: inline-block;
    margin: auto;
    color: #000000;
    font-size: 1.5rem;
  }
  .label-credits{
    margin-right:174px;
  }
  .checked-credit{
    margin-bottom: 40px;
  }
  .line-separator{
    height: 1px;
    width: 100%;
    background: #D9D9D9;
    margin-top:18px;
    margin-bottom: 24px;
  }
  @media all and (min-width: 768px) {
    .payment-container{
      max-width: 370px;
      margin: 0 auto;
    }
  }
  .small-muted-text{
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #767676;
    margin-bottom: 18px;
  }
  .input-radio{
    margin-right: 26px;
    padding-top:4px;
  }
  .duration-text{
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    color: #4D4D4D;
    text-align: left;
    margin-bottom: 10px;
  }
  .duration-images img{
    width: auto;
    height: 16px;
    margin-right: 9px;
  }
  .payment-item{
    margin-bottom: 40px;
  }
  .input-radio-payment{
    margin-right: 26px;
  }
  .payment-method-label{
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    line-height: 24px;
    color: #4D4D4D;
  }
  .payment-method-images img{
    width: auto;
    height: 16px;
    margin-left: 6px;
  }
</style>



// WEBPACK FOOTER //
// src/views/TopUp.vue